import { ChangeDetectionStrategy, Component, DOCUMENT, Inject, resource } from '@angular/core';
import { environment } from 'libs/core/src/lib/environments/environment';
import { IcImpersonationBannerComponent } from 'libs/core/src/lib/componets/ic-impersonation-banner.component';
import { IcNoticeBannerComponent } from 'libs/core/src/lib/componets/ic-notice-banner.component';
import { LoadingBarModule } from '@ngx-loading-bar/core';
import { RouterOutlet } from '@angular/router';
import { getVersionInfo } from '@inshuwa-client/shared-version';
import { IcCommandPaletteComponent, routesToCommandItems } from 'libs/shared-modules/src/lib/command-palette/ic-command-palette.component';
import { IcUpdateToastComponent } from 'libs/shared-modules/src/lib/update-toast/ic-update-toast.component';

@Component({
  selector: 'ic-agents-portal-root',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <ngx-loading-bar color="var(--primary-color, #520B4D)"></ngx-loading-bar>
    <ic-impersonation-banner />
    <ic-notice-banner />
    <router-outlet />
    <ic-command-palette [items]="commandItems.value()" />
    <ic-update-toast />
    <span class="ic-version-tag">{{ versionInfo.version }}</span>
  `,
  styles: ['.ic-version-tag { position: fixed; bottom: 4px; right: 8px; font-size: 10px; color: #9ca3af; pointer-events: none; z-index: 9999; }'],
  imports: [LoadingBarModule, RouterOutlet, IcImpersonationBannerComponent, IcNoticeBannerComponent, IcUpdateToastComponent, IcCommandPaletteComponent],
})
export class AppComponent {
  title = 'agents-portal';
  env = environment;
  versionInfo = getVersionInfo();
  // Lazy: dashboard.routes references the non-standalone dashboard shell, which would drag
  // IcUiModule (ng-zorro, echarts, tiptap...) into the initial bundle if imported eagerly.
  commandItems = resource({
    loader: () =>
      import('./dashboard/dashboard.routes').then((m) =>
        routesToCommandItems(m.routes, '/dashboard'),
      ),
    defaultValue: [],
  });

  constructor(@Inject(DOCUMENT) private document: Document) {
    this.document
      .getElementById('appFavicon')
      ?.setAttribute('href', environment.favIcon);
  }
}
